import { BuyGuideVendorRebateProgramTiersGrowths } from '../../../components/BuyGuide';

export function BuyGuideRebateProgramTiersGrowths() {
  return <BuyGuideVendorRebateProgramTiersGrowths />;
}
